import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Grid from "../../../../elements/Grid";

var ListOfLinksColumn = function ListOfLinksColumn(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(ListOfLinksColumn.displayName); // NB here the root element does not possess the root classname, as it needs
  // to be a Grid.Item. This complicates CSS selectors somewhat, but is
  // necessary to reduce duplicating Grid implementation.

  return /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement("ul", {
    className: getClassName()
  }, children));
};

ListOfLinksColumn.displayName = "ListOfLinks.Column";
ListOfLinksColumn.propTypes = {
  /**
   * LinkOfList Links, BlockLinks or Groups to render.
   */
  children: PropTypes.node.isRequired
};
export default ListOfLinksColumn;